import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../../components/Utils/CallApi";
import { setPageLoadingTrue, setPageLoadingFalse } from "../appSlice";
import { setError } from "../appSlice";

export const fetchNews = createAsyncThunk(
  "news/fetchNews",
  async (
    { companyId, sectionType, page, limit, categoryId },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(setPageLoadingTrue());

      let params = `companyId=${companyId}&sectionType=${sectionType}&page=${page}&limit=${limit}`;

      if (categoryId) {
        params += `&categoryId=${categoryId}`;
      }

      const response = await get("sections/data/list", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const saveNews = createAsyncThunk(
  "news/saveNews",
  async (
    { payload, sectionId, files },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      dispatch(setPageLoadingTrue());
      const state = getState();
      const response = await post(
        "sections/data/save",
        payload,
        state.app,
        sectionId,
        files
      );

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const getNews = createAsyncThunk(
  "news/getNews",
  async ({ id, sectionType }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = `id=${id}&sectionType=${sectionType}`;
      const response = await get("sections/data/get", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

const newsSlice = createSlice({
  name: "news",
  initialState: {
    newsContent: [],
    loading: false,
    error: null,
  },
  reducers: {
    addNews: (state, action) => {
      if (action.payload) {
        state.newsContent.push(action.payload);
      }
    },
    editNews: (state, action) => {
      const index = state.newsContent.findIndex(
        (news) => news.id === action.payload.id
      );
      if (index !== -1) {
        state.newsContent[index] = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch news
      .addCase(fetchNews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNews.fulfilled, (state, action) => {
        state.loading = false;
        state.newsContent = action.payload;
      })
      .addCase(fetchNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Save news
      .addCase(saveNews.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveNews.fulfilled, (state, action) => {
        state.loading = false;
        state.newsContent = action.payload;
      })
      .addCase(saveNews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { addNews, editNews } = newsSlice.actions;
export default newsSlice.reducer;
